"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-nocheck
(function () {
    var exports = {
        initializeErrorMessageHandling: function () {
            $('.gs1completeorder-udipolicydeclaration-form').find('.mandatory-message').find('a').on('click', function (event) {
                event.preventDefault();
                var $anchor = $(this);
                var $targetElement = $($anchor.attr('href'));
                var targetOffset = $targetElement.offset().top;
                $('html,body').animate({
                    scrollTop: targetOffset
                }, 500, function () {
                    $targetElement.trigger('focus');
                    $targetElement.trigger('select');
                });
            });
        }
    };
    exports.initializeErrorMessageHandling();
})();
exports.default = {};
